import classNames from 'classnames';
import styles from './styles.module.scss';
import React from 'react';
import {Spinner} from '@chakra-ui/react';
import {AlertTypes} from '../../enums/api';

const StyledButton: React.FC<{
  children: React.ReactNode;
  isLoading: boolean;
  nativeClassNames?: string;
  variant?: AlertTypes;
  onClick?: () => void;
}> = ({children, isLoading, nativeClassNames, variant = '', onClick = () => {}}) => {
  return (
    <div className={classNames(styles.btn, styles[variant], nativeClassNames)} onClick={onClick}>
      {isLoading ? <Spinner /> : children}
    </div>
  );
};

export default StyledButton;
